/* eslint-disable import/no-named-as-default */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
// import { useCallback, useState } from 'react';
import { useState } from 'react';
// formik imports
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton } from '@material-ui/lab';
import { Box, Card, Grid, Stack, Button } from '@material-ui/core';
import { AddCircleOutlineOutlined } from '@material-ui/icons';
// utils
// routes
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import {
  createNewCampaignRule,
  updateCampaignRule
  // eslint-disable-next-line import/no-unresolved
} from 'src/redux/slices/campaignrules';

import AddExtraCampaignRule from './AddExtraCampaignRule';

// ----------------------------------------------------------------------

CampaignRuleForm.propTypes = {
  editId: PropTypes.object,
  handleClose: PropTypes.func,
  parentRuleId: PropTypes.number
};

export default function CampaignRuleForm({ editId, handleClose, parentRuleId }) {
  // const { createRuleStatus, error } = useSelector((state) => state.campaignrules);
  const dispatch = useDispatch();
  const [btnSelect, setBtnSelect] = useState(false);

  const emptyRule = [
    {
      id: 0,
      column_name: '',
      if_cell_value: '',
      value_or_text: ''
    }
  ];

  const editRules = editId?.data;

  const tempRules = editId ? editRules : emptyRule;

  const [rules, setRule] = useState(tempRules);
  //

  const handleAddRule = () => {
    setRule([
      ...rules,
      {
        id: parseInt(1 + Math.random() * (1000 - 1), 10),
        if_cell_value: '',
        value_or_text: '',
        column_name: ''
      }
    ]);
    setBtnSelect(false);
  };

  const handleDeleteRule = (id) => {
    const updatedRules = rules.filter((rule) => rule.id !== id);
    setRule(updatedRules);
    console.log('RulesLength', rules.length);
    if (rules.length < 2) setBtnSelect(true);
  };

  const ValidationSchema = Yup.object().shape({
    rules: Yup.array(
      Yup.object({
        column_name: Yup.mixed().required('*Required'),
        if_cell_value: Yup.mixed().required('*Required'),
        value_or_text: Yup.mixed().required('*Required')
      })
    )
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      parentRuleId,
      rules
    },
    validationSchema: ValidationSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        const campaignRuleData = {
          rules: values.rules
        };
        setSubmitting(false);

        if (editId) {
          dispatch(updateCampaignRule(campaignRuleData, editId.ruleId));
        } else {
          dispatch(createNewCampaignRule(campaignRuleData, parentRuleId));
        }

        handleClose();
      } catch (error) {
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { errors, values, handleSubmit, isSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              {/* [...Array(fields)] */}
              {rules.map((rule, index) => (
                <AddExtraCampaignRule
                  data={rule}
                  id={index}
                  key={index}
                  handleDeleteRule={handleDeleteRule}
                  setRule={setRule}
                  rules={rules}
                  errors={errors}
                  editId={editId}
                />
              ))}
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent="space-between">
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
                  {!editId && (
                    <Button
                      variant="text"
                      startIcon={<AddCircleOutlineOutlined />}
                      onClick={handleAddRule}
                      sx={{ width: '10%', height: '3rem', display: 'flex', justifyContent: 'space-around' }}
                      title="Add"
                    />
                  )}
                </Stack>
              </Stack>
              <Stack spacing={3}>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <LoadingButton sx={{ marginRight: '1rem' }} type="button" variant="outlined" onClick={handleClose}>
                    Cancel
                  </LoadingButton>
                  <LoadingButton
                    sx={{ marginRight: '1rem' }}
                    type="submit"
                    variant="contained"
                    loading={isSubmitting}
                    disabled={btnSelect}
                  >
                    {!editId ? 'Save' : 'Update Changes'}
                  </LoadingButton>
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
